// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file onboarding/get_medical_inventory_stock.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { MedicalInventoryItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetMedicalInventoryStockRequest
 */
export class GetMedicalInventoryStockRequest extends Message<GetMedicalInventoryStockRequest> {
  /**
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * @generated from field: string search = 3;
   */
  search = "";

  constructor(data?: PartialMessage<GetMedicalInventoryStockRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetMedicalInventoryStockRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMedicalInventoryStockRequest {
    return new GetMedicalInventoryStockRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMedicalInventoryStockRequest {
    return new GetMedicalInventoryStockRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMedicalInventoryStockRequest {
    return new GetMedicalInventoryStockRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMedicalInventoryStockRequest | PlainMessage<GetMedicalInventoryStockRequest> | undefined, b: GetMedicalInventoryStockRequest | PlainMessage<GetMedicalInventoryStockRequest> | undefined): boolean {
    return proto3.util.equals(GetMedicalInventoryStockRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetMedicalInventoryStockResponse
 */
export class GetMedicalInventoryStockResponse extends Message<GetMedicalInventoryStockResponse> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.MedicalInventoryItem items = 1;
   */
  items: MedicalInventoryItem[] = [];

  constructor(data?: PartialMessage<GetMedicalInventoryStockResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetMedicalInventoryStockResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: MedicalInventoryItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMedicalInventoryStockResponse {
    return new GetMedicalInventoryStockResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMedicalInventoryStockResponse {
    return new GetMedicalInventoryStockResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMedicalInventoryStockResponse {
    return new GetMedicalInventoryStockResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMedicalInventoryStockResponse | PlainMessage<GetMedicalInventoryStockResponse> | undefined, b: GetMedicalInventoryStockResponse | PlainMessage<GetMedicalInventoryStockResponse> | undefined): boolean {
    return proto3.util.equals(GetMedicalInventoryStockResponse, a, b);
  }
}

